/* tslint:disable: variable-name max-classes-per-file */
import { Conta } from './Conta';
import { BankData } from './BankData';
import { Endereco } from './Endereco';
import { Suitability } from './Suitability';
import { ImportedBy } from '../enum/user/importedby';

// FIXME: Algumas coisas aqui podem ser interfaces, apenas User tem sido construída
export class User {

    public id: number;
    public user: any;
    public phone: any;
    public personType: number;
    public pending: any;

    public importedBy: ImportedBy;

    /**
     * Passo 1 ( Base )
     */
    public personalData: {
        name: string;
    };

    public name: string;
    public email: string;
    public Phone: any;
    public cpfcnpj: string;
    public phoneNumber: any;
    public phoneAreaCode: any;

    /**
     * Passo 2 ( Dados Pessoais )
     */
    public gender: any; // Sexo
    public genderDescription: string;
    public birthDate: string; // Data de nascimento
    public educationDegreeID: number; // Formação acadêmica
    public jobTypeID: number;
    public jobTypeDescription: string;
    public maritalStatusID: any;
    public birthStateID: number;
    public birthCityID: number;
    public birthCountryID: number;
    public spouseName: string;
    public spouseCPF: string;
    public motherName: string;
    public bankAccounts = [];
    public fatherName: string;
    public investKnowledge: string;
    public investIntends: number;
    public investEducationKnowledge: number;
    public schooling: any;
    public nationalityID: number;
    public birthCountry: any;
    public FinanceInformation: FinanceInformation;
    public Suitability: Suitability;
    public economicActivity: any;
    public companyType: string;
    public stateID: number;
    public cityID: number;
    public number: number|string;
    public district: string;
    public zipCode: number|string;
    public complement: string;
    public isUSPerson: boolean;
    public isPoliticalExposedPerson: boolean;
    public responsibleName: any;
    public responsibleDocumentNumber: any;
    public streetName: any;
    public riskType: number;
    /**
     * Passo 3 ( Documentação )
     */
    public responsableTaxpayerRegistration: string; // CPF Responsável
    public responsableName: string;
    public cnh: CNH;
    public rg: RG;
    public identificationDocumentIssuedStateID: any;
    public identificationDocumentEmitterID: any;
    public identificationDocumentIssuedDate: any;
    public identificationDocumentNumber: any;
    public identificationDocumentSecurityCode: any;
    public identificationDocumentTypeID: any;

    /**
     * Passo 4 ( Banco )
     */
    public bankData: BankData;


    /**
     * Passo 5 ( Patrimônio )
     */
    public isEmployed: any; // Informa se o usuário está trabalhando atualmente // Se sim:
    public companyCNPJ: string; // CNPJ da empresa
    public companyName: string; // Nome da empresa
    public IncomeValue: IncomeValue; // Salário bruto mensal
    public Attorney: Record<string, any>; // Default empty
    public Document: Document;
    public CnhCodigo: string;
    public OtherPrefession: string; // ?
    public Endereco: Endereco;
    public Conta: Conta;
    public Intent: Intent;
    public MinorInformation: Record<string, any>;
    public ActiveStep: number;
    public Terms: boolean;
    public HistoryInvestments: Suitability;
    public PublicPerson: boolean;
    public UsPerson: boolean;
    public Procuradores: boolean;
    // suitability
    public monthlySalary: number;
    public hasExtraIncome: boolean;
    public extraIncome: number;
    public immovablePropertiesValue: number;
    public movablePropertiesValue: number;
    public TotalIncome: number;
    public IntentUse: number;

    public profile: number|string;
    public registrationStatus: number;
    public representatives: any[];
    public emitters: any[];
    public attorneys: any[];
    public partners: any[];
    public equity: any;
    public relatedCompanies: any[];
    public campaignName: string;

    constructor() {
        this.Endereco = new Endereco();
        this.bankData = new BankData();
        this.Conta = new Conta();
        this.Attorney = {};
        this.MinorInformation = {};
        this.ActiveStep = 1;
        this.Suitability = new Suitability();
        this.FinanceInformation = new FinanceInformation();
        this.Document = new Document();
        this.IncomeValue = new IncomeValue();
        this.Intent = new Intent();
        this.HistoryInvestments = new Suitability();

        this.cnh = new CNH();
        this.rg = new RG();
    }

}

export class CNH {
    public number: string;
    public securityCode: string;
    public emissionDate: string;
    public emissionOrganFederatedState: string;
}

export class RG {
    public number: string;
    public emissionDate: string;
    public emissionOrgan: string;
    public emissionOrganFederatedState: string;
}

class Cell {
    public id: string;
    public number: string;
    public areaCode: string;
}

class IncomeValue {
    public Value: string;
}

class Intent {
    public Objetivo: number;
    public Time: number;
    public Risk: number;
}

class FinanceInformation {

    /**
     * Passo 2
     */
    public valueIntendsToInvest: number;
    public Liquity: number;
    public Bank: number;
    public Agency: string;
    public AccountNumber: string;
    public Type: number;
    public Nivel: number;
    public Shared: boolean;
    public SharedCPF: string;
    public SharedName: string;

    public HasExtraIncome: number; // Flag que indica se o cliente possui outras rendas e/ou patrimônios
    public ValueOfExtraIncome: string; // Valor de outras rendas
    public ValueOfImmovableProperty: string; // Valor total dos bens imóveis
    public ValueOfMovableProperty: string; // Valor total dos bens móveis

    public TotalIncome: string;
    public IntentUse: number;
    public monthInvestment: number;
}

class Document {
    public Type: number;
    public Info: DocInfo;
    constructor() {
        this.Info = new DocInfo();
    }
}

class DocInfo {
    public OrgaoEmissor: string;
    public Codigo: string;
    public Numero: number;
    public docOrigem: number;
    public Emissao: string;
    public UF: number;
    public LegalResponsable: string;
    public CPFResponsavel: string;
}
